module.exports = __webpack_public_path__ + "img/mobilehardware8.d3c49ae3.png";